export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5268.44f3ddb3.jpg";